// Dependency imports
import { useState } from 'react';
import { Box, Tab, Tabs, Tooltip } from '@mui/material';

import AddIcon from '@mui/icons-material/Add';

// Local imports
import Cameras from './camera/camera';
import { Modal } from 'components';
import { Help } from '@mui/icons-material';
import AddCamera from './camera/addCamera';
import { useListCameraDetails } from 'api/sdk';

const Settings = () => {
  const [name, setName] = useState<string>('');
  const [url, setUrl] = useState<string>('');
  const [openModel, setOpenModel] = useState<boolean>(false);
  const { refetch, data } = useListCameraDetails();

  return (
    <div className="w-full p-4 flex flex-col gap-2">
      <div className="flex w-full items-center justify-between">
        <h2 className="text-[1.1vw] font-[Proxima-Nova-Bold]">Settings</h2>
        <div className="w-full flex flex-row items-center justify-end gap-2">
          <Tooltip
            title={
              <div>
                <h4 style={{ margin: 0, padding: 0, fontSize: '14px' }}>
                  Requirements
                </h4>
                <p>
                  RTSP camera ( either a camera that will route via. RTSP server
                  or IP webcam app (android only))
                </p>
                <p>
                  A model trained after the release with at least 20 videos for
                  300 epochs (if the model converges , it'll get saved and stop
                  training)
                </p>
                <p>live inference with the same setup as the training videos</p>
              </div>
            }
            sx={{ cursor: 'pointer' }}
          >
            <Help />
          </Tooltip>
          <button
            onClick={() => {
              setName('');
              setUrl('');
              setOpenModel(true);
            }}
            className="bg-[#102433] px-[3vw] py-[5px] text-white text-[0.8vw] rounded-sm flex items-center justify-start gap-2"
          >
            <AddIcon className="w-[1vw]" />
            Camera
          </button>
        </div>
      </div>
      <Cameras
        url={url}
        setUrl={setUrl}
        data={data}
        refetch={refetch}
        setName={setName}
        name={name}
      />
      <Modal
        open={openModel}
        onClose={() => {
          setOpenModel(false);
        }}
        size="md"
      >
        <AddCamera
          url={url}
          name={name}
          setName={setName}
          setUrl={setUrl}
          setOpenModel={setOpenModel}
          refetch={refetch}
        />
      </Modal>

      {/* <Tabs
        value={value}
        onChange={handleChange}
        aria-label="basic tabs example"
      >
        <Tab label="Cameras" sx={{ fontSize: '0.9vw', fontWeight: 'bold' }} />
      </Tabs>
      <CustomTabPanel value={value} index={0}>
        
      </CustomTabPanel> */}
    </div>
  );
};

export default Settings;
